import { render, staticRenderFns } from "./AnimationControlButton.vue?vue&type=template&id=061810cf&scoped=true"
import script from "./AnimationControlButton.vue?vue&type=script&lang=ts"
export * from "./AnimationControlButton.vue?vue&type=script&lang=ts"
import style0 from "./AnimationControlButton.vue?vue&type=style&index=0&id=061810cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061810cf",
  null
  
)

export default component.exports